import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { notify } from 'libs/common';
import { Confirm, themes } from 'libs/ui';
import { changeClientStatus } from 'services/client-service';
import { ToggleBox, Toggle, UpdateMessageStyled } from './client-activity.styled';

export const ClientActivity = (props) => {
  const { client, refresh } = props;
  const { t } = useTranslation();
  const [status, setStatus] = useState(client.status);
  const [warning, setWarning] = useState(false);
  const [updateMessage, setUpdateMessage] = useState(false);

  const rightChangeStatus = user.haveRight('clients.change_status');
  const isActive = status === 'active';

  /**
   * toggle client status with warning
   * @returns
   */
  const toggleStatus = () => {
    if (!rightChangeStatus) {
      return false;
    }

    if (isActive) {
      setWarning(true);
    } else {
      changeStatus();
    }
  };

  /**
   * set client status
   */
  const changeStatus = () => {
    const newStatus = isActive ? 'blocked' : 'active';
    changeClientStatus(client.id, newStatus)
      .then(() => {
        setStatus(newStatus);
        setUpdateMessage(true);
        setTimeout(() => {
          setUpdateMessage(false);
        }, 2500);
        closeWarning();
        refresh();
      })
      .catch((error) => notify('Изменение статуса', error.toString()));
  };

  /**
   * close warning
   */
  const closeWarning = () => {
    setWarning(false);
  };

  /**
   * get update msg text
   * @returns
   */
  const getMessage = () => {
    return isActive ? t('messages.Клиент успешно разблокирован') : t('messages.Клиент успешно заблокирован');
  };

  return (
    <>
      <ToggleBox isActive={isActive}>
        <p>{t('grid.Блокирован')}</p>
        <Toggle disabled={!rightChangeStatus} isActive={isActive} onClick={toggleStatus}>
          <div></div>
        </Toggle>
        <p>{t('grid.Активен')}</p>
      </ToggleBox>

      {warning && (
        <Confirm
          width={'540px'}
          title={t('messages.Блокировка клиента')}
          info={
            <div>
              {t('messages.Блокировка клиента приведет к блокировке всех СО этого клиента')} <br />
              {t('messages.Заблокировать клиента')} {client.name}?
            </div>
          }
          type="danger"
          cancelButton={{
            text: t('buttons.Отменить'),
            func: closeWarning,
          }}
          acceptButton={{
            text: t('buttons.Заблокировать клиента'),
            func: changeStatus,
            theme: themes.red,
            img: '/images/icon_lock.png',
          }}
        />
      )}

      {updateMessage && <UpdateMessageStyled>{getMessage()}</UpdateMessageStyled>}
    </>
  );
};
